import { createApi } from '@reduxjs/toolkit/query/react';

import { createBaseQuery } from './createBaseQuery';

export interface IScenariosSortResponse {
  played: unknown[];
  custom: unknown[];
  newest: unknown[];
  best: unknown[];
}

export type ScenarioSortType = 'public' | 'custom' | 'dialogs' | 'best';

export interface IScenariosSortByTypeParams {
  type: ScenarioSortType;
  withDialogs?: boolean;
  tags?: string[];
}

export const scenariosApi = createApi({
  reducerPath: 'scenariosApi',
  baseQuery: createBaseQuery(),
  tagTypes: ['Scenarios'],
  keepUnusedDataFor: 3600,
  endpoints: (builder) => ({
    getScenariosSort: builder.query<IScenariosSortResponse, void>({
      query: () => ({
        url: '/scenarios/sort',
        method: 'GET',
      }),
      providesTags: ['Scenarios'],
    }),

    getScenariosSortByType: builder.query<unknown[], IScenariosSortByTypeParams>({
      query: ({ type, withDialogs = false, tags = [] }) => ({
        url: `/scenarios/sort/${type}`,
        method: 'GET',
        params: {
          withDialogs,
          // Отправляем массив тегов как отдельные параметры tags=tag1&tags=tag2
          ...(tags.length > 0 && { tags }),
        },
      }),
      providesTags: ['Scenarios'],
    }),
  }),
});

export const {
  useGetScenariosSortQuery,
  useLazyGetScenariosSortQuery,
  useGetScenariosSortByTypeQuery,
  useLazyGetScenariosSortByTypeQuery,
} = scenariosApi; 